import type { NuxtOptions } from '@nuxt/schema'
import type { FetchOptions } from 'ofetch'
import type { Ref } from 'vue'
import { getProxyRequestHeaders } from 'h3'

type ExtractLocaleType<T> = T extends { locales?: (infer L)[] } ? L : never

type ExtractLocaleObject<T> = ExtractLocaleType<T> extends (string | { code: string })
  ? Extract<ExtractLocaleType<T>, { code: string }>
  : never

export type LocaleObject = ExtractLocaleObject<NuxtOptions['i18n']>

export default defineNuxtPlugin({
  name: 'graphql-config',
  dependsOn: ['nuxt-graphql-middleware-provide-state'],
  setup(nuxtApp) {
    const state = useGraphqlState()

    if (!state)
      throw new Error('GraphQL state not available.')

    const locale = ((nuxtApp.$i18n as any).locale as Ref<string>).value
    const localeObject = ((nuxtApp.$i18n as any).locales as Ref<LocaleObject[]>).value.find(l => l.code === locale)

    const event = useRequestEvent()

    const log = useCoreLog('graphql-middleware')

    state.fetchOptions = {
      headers: event ? getProxyRequestHeaders(event) : undefined,
      onRequest: (context) => {
        context.options.params ??= {}
        context.options.params.languageCode = (localeObject?.language ?? 'en').split('-')[0]
        context.options.params.currencyCode = localeObject?.currency ?? 'USD'
      },
      onResponse(result) {
        const body = result.response._data as any
        if (body.errors?.length) {
          log.error('GraphQL response errors:', body.errors)
        }
      },
    } satisfies FetchOptions
  },
})
